import { AutogenModelEdiRequiredFieldOutboundTender, AutogenRowEdiRequiredFieldOutboundTender } from "./autogen/AutogenModelEdiRequiredFieldOutboundTender";

export class ModelEdiRequiredFieldOutboundTender extends AutogenModelEdiRequiredFieldOutboundTender<RowEdiRequiredFieldOutboundTender> {
	constructor() {
		super(RowEdiRequiredFieldOutboundTender);
	}
}

export class RowEdiRequiredFieldOutboundTender extends AutogenRowEdiRequiredFieldOutboundTender {
}